import { Brand } from "./brand"

export type AppRoute = Brand<string, 'AppRoute'>

export type Path =
    | 'accessRevoked'
    | 'contract'
    | 'contractList'
    | 'contracts'
    | 'dealerInvoice'
    | 'deniedUsers'
    | 'membership'
    | 'newContract'
    | 'newOrganization'
    | 'newVehiclePurchase'
    | 'order'
    | 'orderList'
    | 'orders'
    | 'organization'
    | 'organizations'
    | 'organizationsList'
    | 'pendingPayments'
    | 'purchasingCoOp'
    | 'reports'
    | 'sellerVehicles'
    | 'templateList'
    | 'vehicleLimitAdjustments'
    | 'vehicleReport'
    | 'user'
    | 'users'
    | 'usersList'
    | 'vehicleClassList'
    | 'vehicles'
    | 'vehicleTypeList'

export namespace AppRoute {
    export const create = (paths: Path[], param?: string | number) => `/${paths.join('/')}${param ? '/' + param : ''}` as AppRoute

    export const PATHS: Record<Path, Path> = {
        accessRevoked: 'accessRevoked',
        contract: 'contract',
        contractList: 'contractList',
        contracts: 'contracts',
        dealerInvoice: 'dealerInvoice',
        deniedUsers: 'deniedUsers',
        membership: 'membership',
        newContract: 'newContract',
        newOrganization: 'newOrganization',
        newVehiclePurchase: 'newVehiclePurchase',
        order: 'order',
        orderList: 'orderList',
        orders: 'orders',
        organization: 'organization',
        organizations: 'organizations',
        organizationsList: 'organizationsList',
        pendingPayments: 'pendingPayments',
        purchasingCoOp: 'purchasingCoOp',
        reports: 'reports',
        sellerVehicles: 'sellerVehicles',
        templateList: 'templateList',
        vehicleLimitAdjustments: 'vehicleLimitAdjustments',
        vehicleReport: 'vehicleReport',
        user: 'user',
        users: 'users',
        usersList: 'usersList',
        vehicleClassList: 'vehicleClassList',
        vehicles: 'vehicles',
        vehicleTypeList: 'vehicleTypeList',
    }
}